'use es6';

import createAction from 'flux-actions/createAction';
import { FETCHED_LIST_REGISTRATIONS, RECEIVED_LIST_REGISTRATIONS, REQUESTED_LIST_REGISTRATIONS, REQUESTED_LIST_REGISTRATIONS_FAILED } from './ActionTypes';
export const requestListRegistrations = createAction(REQUESTED_LIST_REGISTRATIONS);
export const receiveListRegistrations = createAction(RECEIVED_LIST_REGISTRATIONS, lists => ({
  lists
}));
export const requestedListRegistrationsFailed = createAction(REQUESTED_LIST_REGISTRATIONS_FAILED, error => ({
  error
}));
export const fetchListRegistrations = createAction(FETCHED_LIST_REGISTRATIONS, listIds => ({
  listIds
}));